(() => {
  const header = document.getElementById('header-group');
  if (!header || !document.body.classList.contains('bra-mockup') || header.dataset.braScrollReady) return;
  header.dataset.braScrollReady = 'true';

  const scrollPosition = () => Math.max(0, Math.min(window.scrollY, document.documentElement.scrollHeight - window.innerHeight));
  let previous = scrollPosition();
  let frame = 0;
  const show = () => header.classList.remove('bra-header-is-hidden');

  function update() {
    frame = 0;
    const current = scrollPosition();
    const delta = current - previous;
    previous = current;
    if (current <= 0 || header.contains(document.activeElement) || header.querySelector('details[open]')) {
      show();
      return;
    }
    if (!delta) return;
    header.classList.toggle('bra-header-is-hidden', delta > 0);
  }

  window.addEventListener('scroll', () => {
    if (!frame) frame = requestAnimationFrame(update);
  }, { passive: true });
  header.addEventListener('focusin', show);
  window.addEventListener('pageshow', () => {
    previous = scrollPosition();
    show();
  });
})();
